import modalStyle from "../../components/Vehicles/RequestVehicle/index.module.css";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import BreadCrumbs from "../../components/General/BreadCrumbs";
import SidebarBox from "../../components/General/SidebarBox";
import { Success, Heart, HeartFilled, Minus, Plus, Share, Warning } from "../../components/Icons";
import ShowroomsList from "../../components/Showrooms/ShowroomsList";
import SingleShowroomCard from "../../components/Showrooms/SingleShowroomCard";
import LoadingSkeleton from "../../components/UI/LoadingSkeleton";
import SingleUsedVehicleCard from "../../components/Vehicles/SingleUsedVehicleCard";
import AvailableColors from "../../components/Vehicles/SingleVehicle/AvailableColors";
import ClassDifferences from "../../components/Vehicles/SingleVehicle/ClassDifferences";
import ContactUsedCar from "../../components/Vehicles/SingleVehicle/ContactUsedCar";
import VehicleHeader from "../../components/Vehicles/SingleVehicle/VehicleHeader";
import VehicleSpecs from "../../components/Vehicles/SingleVehicle/VehicleSpecs";
import Button from "../../components/UI/Button";
import { selectUser } from "../../store/userSlice";
import { getArticles, getBannersFiltered, getSingleVehicle, getDistributorVehicle } from "../../utils/fetcher";
import { VehicleConditions, vehicleModules, VehicleNames } from "../../utils/GeneralTypes";
import Modal from "../../components/UI/Modal";
import { getCompareVehicles, updateCompare, updateWishlist } from "./utils";
import { useHistory, useParams } from "react-router";
import style from "./index.module.css";
import RequestVehicle from "../../components/Vehicles/RequestVehicle";
import LatestNews from "../../components/News/LatestNews";
import ReportVehicle from "../../components/Vehicles/ReportVehicle";
import { useScrollToTop } from "../../utils/generalUtils";
import ViewMore from "../../components/Vehicles/ViewMore";
import Banner from "../../components/Vehicles/Banner";
import noImagePlaceholder from "../../assets/images/romotors-no-image-available-notext.jpg";
import { useTranslation } from "../../hooks/useTranslation";
import Gallery from "../../components/Vehicles/SingleVehicle/VehicleSpecs/Gallery";
import SingleVehicleCard from "../../components/Vehicles/SingleVehicleCard";

// TODO: add types instead of any
type componentDataT = {
  vehicle: any;
  similarVehicles: any;
  news: any;
  banners: any;
};

const VehiclePage = ({ vehicleNames, vehicleCondition, isImported, isForDistributor }: ComponentPropsType) => {
  const { locale, siteLang } = useTranslation();
  const history = useHistory<any>();
  const { vehicleID } = useParams<{ vehicleID: string }>();
  const { user } = useSelector(selectUser);
  const [showWishlistMessage, setShowWishlistMessage] = useState(false);

  const initialMount = useRef<boolean>(true);

  useScrollToTop();

  const [componentData, setComponentData] = useState<{
    isFetching: boolean;
    data: componentDataT;
  }>({
    isFetching: true,
    data: {
      vehicle: null,
      similarVehicles: null,
      news: null,
      banners: null,
    },
  });

  const [vehicleExtraInfo, setVehicleExtraInfo] = useState<{
    wishlist: boolean;
    compare: boolean;
  }>({ wishlist: false, compare: false });

  const [isWarningModalActive, setIsWarningModalActive] = useState<boolean>(false);
  const [isComparingModalActive, setIsComparingModalActive] = useState<boolean>(false);
  const [isAddedToCompare, setIsAddedToCompare] = useState<boolean>(false);
  const [isRequestingModalActive, setIsRequestingModalActive] = useState<boolean>(false);

  useEffect(() => {
    if (!initialMount.current) {
      setComponentData((current) => ({
        ...current,
        isFetching: true,
      }));
    }
    initialMount.current = false;
    const data: componentDataT = {
      vehicle: null,
      similarVehicles: null,
      news: null,
      banners: null,
    };

    (async () => {
      const res = await Promise.all([
        isForDistributor
          ? getDistributorVehicle(vehicleNames.single, +vehicleID)
          : getSingleVehicle(vehicleNames.single, vehicleCondition, +vehicleID),
        getArticles("?number=2"),
        getBannersFiltered(`${vehicleCondition}_${vehicleNames.plural}`),
        // getBannersFiltered(
        //   `${
        //     vehicleCondition.slice(0, 1).toUpperCase() + vehicleCondition.slice(1)
        //   }_${vehicleNames.single}`
        // ),
      ]);
      data.vehicle = res[0]?.data?.vehicle;
      data.similarVehicles = res[0]?.data?.related_models;
      data.news = res[1]?.data?.articles;
      data.banners = res[2]?.data?.banners;
      let isWishlisted: boolean = res[0]?.data?.vehicle.wishlisted || false;
      let isCompared: boolean = false;
      const currentCompare = getCompareVehicles();
      if (currentCompare?.vehicles?.[vehicleCondition]?.includes(data?.vehicle?.id?.toString())) isCompared = true;
      if (isWishlisted || isCompared)
        setVehicleExtraInfo({
          wishlist: isWishlisted,
          compare: isCompared,
        });

      setComponentData({
        isFetching: false,
        data,
      });
    })();
  }, [vehicleCondition, vehicleNames, vehicleID, isForDistributor]);

  /**
   * if user not signed redirect them to sign in page, other than that perform the operation
   */
  const onToggleWishlistHandler = useCallback(async () => {
    if (!user) {
      history.replace("/sign");
      return;
    }
    setVehicleExtraInfo((current) => ({
      ...current,
      wishlist: !current.wishlist,
    }));
    await updateWishlist(
      vehicleNames.single,
      vehicleExtraInfo.wishlist ? "delete" : "add",
      componentData.data.vehicle.id.toString(),
    );
    setShowWishlistMessage(true);
  }, [user, vehicleNames.single, vehicleExtraInfo.wishlist, componentData, history]);

  const onCloseWishlistMessage = useCallback(() => {
    setShowWishlistMessage(false);
  }, []);
  const onToggleCompareHandler = useCallback(() => {
    const compareIsFull = updateCompare(
      vehicleNames.single,
      vehicleCondition,
      componentData.data.vehicle.id.toString(),
    );
    if (compareIsFull) {
      setIsComparingModalActive(true);
    } else {
      if (!vehicleExtraInfo.compare) {
        setIsAddedToCompare(true);
      }
      setVehicleExtraInfo((current) => ({
        ...current,
        compare: !current.compare,
      }));
    }
  }, [componentData.data, vehicleNames, vehicleCondition, vehicleExtraInfo]);

  return (
    <>
      {showWishlistMessage && (
        <Modal onClose={onCloseWishlistMessage}>
          <div className={modalStyle.modal}>
            <div className={modalStyle.modal_response}>
              <Success width="50" height="50" color="#35b545" />
              <p>
                {vehicleExtraInfo.wishlist ? locale("addedToWishlistSuccess") : locale("removedFromWishlistSuccess")}
              </p>
            </div>
          </div>
        </Modal>
      )}
      {isWarningModalActive && (
        <ReportVehicle
          vehicleID={vehicleID}
          setIsWarningModalActive={setIsWarningModalActive}
          vehicleNames={vehicleNames}
        />
      )}
      {(isComparingModalActive || isAddedToCompare) && (
        <Modal
          onClose={() => {
            setIsComparingModalActive(false);
            setIsAddedToCompare(false);
          }}
        >
          <div className={style.modal}>
            {isAddedToCompare && (
              <p>
                <Success color="#959595" width="55" height="55" />
              </p>
            )}
            <p className={style.modal_title}>
              {isComparingModalActive ? (
                <>
                  {locale("compare_list_full")} {locale(vehicleNames.single).toLocaleLowerCase()}
                </>
              ) : (
                locale("addedToCompare")
              )}
            </p>
            <div className={style.modal_ctas}>
              <Button
                styleType={isComparingModalActive ? "primary_black" : "primary"}
                onClick={() =>
                  isComparingModalActive
                    ? setIsComparingModalActive(false)
                    : history.push(`/compare/${vehicleNames.plural}/${vehicleCondition}`)
                }
              >
                {locale(isComparingModalActive ? "cancel" : "compare")}
              </Button>
            </div>
          </div>
        </Modal>
      )}
      {isRequestingModalActive && (
        <RequestVehicle
          vehicleID={vehicleID}
          vehicleName={`${componentData.data.vehicle?.model?.name} ${componentData.data.vehicle?.model?.year}`}
          vehicleClass={componentData.data.vehicle?.class_name}
          vehiclePrice={componentData.data.vehicle?.price}
          setIsRequestingModalActive={setIsRequestingModalActive}
          vehicleNames={vehicleNames}
        />
      )}
      {/* <div className="main_section">
        <div className="container-lg">
          <div className="section_content_padding">
            <BreadCrumbs
              pages={[
                { text: locale("home"), link: "/" },
                {
                  text: locale(`${vehicleCondition}_${vehicleNames.plural}`),
                  link: `/${vehicleCondition}-${vehicleNames.plural}`,
                },
                {
                  text: componentData.data.vehicle?.model?.brand?.name,
                  link:
                    vehicleCondition === "new"
                      ? `/${vehicleCondition}-${vehicleNames.plural}/brands/${componentData.data.vehicle?.model?.brand?.id}`
                      : `/${vehicleCondition}-${vehicleNames.plural}/find?brand=${componentData.data.vehicle?.model?.brand?.id}`,
                },
                {
                  text: `${componentData.data.vehicle?.model?.brand?.name} ${componentData.data.vehicle?.model?.name} ${componentData.data.vehicle?.model?.year}`,
                  link: "",
                },
              ]}
              isLoading={componentData.isFetching}
            />
          </div>
        </div>
      </div> */}
      <div className="main_section">
        <div className="container-lg">
          <div className="section_content_padding">
            <div className={`${style.page_row} row`}>
              <div className={`col-lg-4 sticky_sidebar ${style.sidebar_box_container}`}>
                {vehicleCondition === "new" &&
                  isForDistributor &&
                  ((componentData.data.vehicle && !componentData.isFetching) || componentData.isFetching) && (
                    <SidebarBox>
                      <div className={style.sidebar_box}>
                        {componentData.isFetching ? (
                          <LoadingSkeleton count={4} height="20px" />
                        ) : (
                          <>
                            <p className={style.text}>
                              {componentData.data.vehicle?.model?.brand?.name +
                                " " +
                                componentData.data.vehicle?.model?.name +
                                " " +
                                componentData.data.vehicle?.model?.year}
                            </p>
                            <span className={style.note}>{componentData.data.vehicle?.class_name}</span>
                            <Button styleType="primary" onClick={() => setIsRequestingModalActive(true)}>
                              {locale("request")}
                            </Button>
                          </>
                        )}
                      </div>
                    </SidebarBox>
                  )}
                {!isForDistributor &&
                ((!componentData.isFetching && componentData.data.vehicle) || componentData.isFetching) ? (
                  <SidebarBox>
                    <div className={style.sidebar_box}>
                      {componentData.isFetching ? (
                        <LoadingSkeleton count={4} height="20px" />
                      ) : (
                        <>
                          <p className={style.text}>
                            {locale(
                              user?.id && user?.id === componentData.data.vehicle?.seller?.user_id
                                ? "edit_my_vehicle"
                                : "place_ad_now",
                            )}
                          </p>
                          <Button
                            styleType="primary"
                            onClick={() =>
                              user
                                ? user?.id && user?.id === componentData.data.vehicle?.seller?.user_id
                                  ? history.push(
                                      `/my-vehicles/${vehicleNames.plural}/edit/${componentData.data.vehicle.id}`,
                                    )
                                  : history.push(`/sell-vehicle/${vehicleNames.single}`)
                                : history.push("/sign")
                            }
                          >
                            {locale(
                              user?.id && user?.id === componentData.data.vehicle?.seller?.user_id
                                ? "edit_my_vehicle"
                                : `sell_my_${vehicleNames.single}`,
                            )}
                          </Button>
                        </>
                      )}
                    </div>
                  </SidebarBox>
                ) : null}
                {componentData.data.banners && componentData.data.banners.length > 0 && (
                  <div style={{ margin: "20px 0" }}>
                    <Banner
                      // TODO: change the type
                      banners={componentData.data.banners.map((banner: any) => ({
                        image: banner.image,
                        url: banner.link,
                      }))}
                      bannerStyle="square"
                      redirection="newPage"
                    />
                  </div>
                )}
              </div>
              <div className="col-lg-8">
                {((componentData.data.vehicle && !componentData.isFetching) || componentData.isFetching) &&
                  (componentData.isFetching ? (
                    <LoadingSkeleton count={20} />
                  ) : (
                    <>
                      <VehicleHeader
                        vehicleState={vehicleCondition}
                        name={`${componentData.data.vehicle?.model?.brand?.name} ${componentData.data.vehicle?.model?.name} ${componentData.data.vehicle?.model?.year}`}
                        model={vehicleCondition === "new" ? componentData.data.vehicle?.class_name : ""}
                        rent={componentData.data.vehicle?.rent}
                        price={componentData.data.vehicle.price}
                        phone={
                          componentData.data.vehicle?.seller?.is_showroom
                            ? componentData.data.vehicle?.seller?.branch?.phone
                            : componentData.data.vehicle?.seller?.user?.phone
                        }
                        has_discount={componentData.data.vehicle.has_discount}
                        old_price={componentData.data.vehicle.old_price}
                        least_deposit={componentData.data.vehicle.least_deposit}
                        least_installment={componentData.data.vehicle.least_installment}
                        maintenance={componentData.data.vehicle.maintence_code}
                        date={
                          vehicleCondition === "used" || vehicleCondition === "imported"
                            ? componentData.data.vehicle.created_at
                            : ""
                        }
                        mileage={
                          vehicleCondition === "used" || vehicleCondition === "imported"
                            ? componentData.data.vehicle.milage
                            : ""
                        }
                      />
                      <div className={`${style.vehicle_image} ${style.vehicle_section}`}>
                        {componentData.data.vehicle.images.length ? (
                          <Gallery
                            gallery={componentData.data.vehicle.images.map((image: any) => image.image)}
                            galleryType="single"
                          />
                        ) : (
                          <img src={componentData.data.vehicle.images[0]?.image || noImagePlaceholder} alt="" />
                        )}
                      </div>
                      <div className={style.vehicle_section}>
                        <VehicleSpecs
                          specs={[
                            {
                              type: "highlights",
                              title: locale("highlights"),
                              highlights: componentData.data.vehicle.attributes.highlights,
                            },
                            {
                              type: "equipment",
                              title: locale("equipment"),
                              equipment: componentData.data.vehicle.attributes.equipments,
                            },
                            {
                              type: "description",
                              title: locale("description"),
                              description: componentData.data.vehicle.description,
                            },
                            {
                              type: "gallery",
                              title: locale("gallery"),
                              gallery_type: vehicleCondition === "new" ? "grid" : "square",
                              gallery: componentData.data.vehicle.images.map((image: any) => image.image),
                            },
                          ]}
                          ctas={[
                            ...(vehicleCondition !== "new"
                              ? [
                                  {
                                    cb: onToggleWishlistHandler,
                                    icon: vehicleExtraInfo.wishlist ? (
                                      <HeartFilled height="20" width="20" color="#dc0000" />
                                    ) : (
                                      <Heart height="20" width="20" color="#dc0000" />
                                    ),
                                  },
                                ]
                              : []),
                            ...(vehicleCondition === "new"
                              ? [
                                  {
                                    cb: onToggleCompareHandler,
                                    icon: vehicleExtraInfo.compare ? (
                                      <Minus height="20" width="20" color="#dc0000" />
                                    ) : (
                                      <Plus height="20" width="20" color="#dc0000" />
                                    ),
                                    label: locale(vehicleExtraInfo.compare ? "uncompare" : "compare"),
                                  },
                                ]
                              : []),
                            ...(vehicleCondition !== "new"
                              ? [
                                  {
                                    cb: () => setIsWarningModalActive(true),
                                    icon: <Warning height="20" width="20" color="#dc0000" />,
                                  },
                                ]
                              : []),
                            ...[
                              {
                                cb: () => {},
                                share: true,
                                icon: <Share height="20" width="20" color="#dc0000" />,
                              },
                            ],
                          ]}
                        />
                      </div>
                      {!isForDistributor ? (
                        <>
                          <div className={`${style.separator} section_content_padding`}>
                            <div className={`${style.separator} section_separator`}></div>
                          </div>
                          <div className={style.vehicle_section}>
                            <ContactUsedCar
                              vehicleType={vehicleNames.single}
                              vehicleState={vehicleCondition}
                              vehicleID={componentData.data.vehicle.id}
                              isUser={!componentData.data.vehicle?.seller?.is_showroom}
                              name={
                                componentData.data.vehicle?.seller.is_showroom
                                  ? componentData.data.vehicle?.seller?.showroom?.name
                                  : componentData.data.vehicle?.seller?.user?.name
                              }
                              email={
                                componentData.data.vehicle?.seller.is_showroom
                                  ? componentData.data.vehicle?.seller?.showroom?.email
                                  : componentData.data.vehicle?.seller?.user?.email
                              }
                              phone={
                                componentData.data.vehicle?.seller.is_showroom
                                  ? componentData.data.vehicle?.seller?.branch?.phone
                                  : componentData.data.vehicle?.seller?.user?.phone
                              }
                              image={
                                componentData.data.vehicle?.seller.is_showroom
                                  ? componentData.data.vehicle?.seller?.showroom?.logo
                                  : ""
                              }
                              note={
                                componentData.data.vehicle?.seller?.region?.name +
                                ", " +
                                componentData.data.vehicle?.seller?.region?.city?.name
                              }
                              showroomID={componentData.data.vehicle?.seller?.showroom_id}
                              ctas={[
                                {
                                  cb: () => {},
                                  phone: true,
                                  icon: <Share height="20" width="20" color="#dc0000" />,
                                },
                                {
                                  cb: () => {},
                                  whatsapp: true,
                                  icon: <></>,
                                },
                              ]}
                            />
                          </div>
                        </>
                      ) : null}
                      {componentData.data.vehicle?.other_showroom_listings &&
                      componentData.data.vehicle?.other_showroom_listings.length > 0 ? (
                        <>
                          <div className={`${style.separator} section_content_padding`}>
                            <div className={`${style.separator} section_separator`}></div>
                          </div>
                          <div className={style.vehicle_section}>
                            <h3 className="main_section__title main_section__title--xsmall">
                              {locale("available_in_showrooms")}
                            </h3>
                            <div className="row">
                              {componentData.data.vehicle?.other_showroom_listings.map((vehicle: any) => (
                                <div className="col-md-6 col-sm-12" key={vehicle.id}>
                                  <SingleVehicleCard
                                    brand={{
                                      image: vehicle?.seller?.showroom?.logo,
                                      link: `/showrooms/showroom/${vehicle?.seller?.showroom?.id}`,
                                      name: vehicle?.seller?.showroom?.name,
                                    }}
                                    has_discount={vehicle.has_discount}
                                    has_free_maintenance={vehicle?.has_free_maintenance}
                                    image={
                                      vehicle.images && vehicle.images.length
                                        ? vehicle.images[0]?.image
                                        : noImagePlaceholder
                                    }
                                    link={`/new-${vehicleModules[0].plural}/${vehicleModules[0].single}/${vehicle.id}`}
                                    model={vehicle?.model?.name}
                                    old_price={vehicle?.old_price}
                                    price={vehicle.price}
                                    year={vehicle?.model?.year}
                                    selling_flag={vehicle?.selling_flag}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </>
                      ) : null}
                      {vehicleCondition === "new" && componentData.data.vehicle.colors?.length > 0 && (
                        <>
                          <div className={`${style.separator} section_content_padding`}>
                            <div className={`${style.separator} section_separator`}></div>
                          </div>
                          <div className={style.vehicle_section}>
                            <h3 className="main_section__title main_section__title--xsmall">
                              {locale("available_colors")}
                            </h3>
                            <AvailableColors
                              colors={componentData.data.vehicle.colors.map((color: any) => ({
                                type: color.image ? "special" : "color",
                                code: color.code,
                                image: color.image,
                              }))}
                            />
                          </div>
                        </>
                      )}
                      {vehicleCondition === "new" &&
                        (componentData.data.vehicle?.lower_model?.attributes?.equipments?.length > 0 ||
                          componentData.data.vehicle?.lower_model?.attributes?.highlights?.length > 0) && (
                          <>
                            <div className={`${style.separator} section_content_padding`}>
                              <div className={`${style.separator} section_separator`}></div>
                            </div>
                            <div className={style.vehicle_section}>
                              <h3 className="main_section__title main_section__title--xsmall">
                                {locale("class_differences")}
                              </h3>
                              <ClassDifferences
                                differences={[
                                  ...componentData.data.vehicle.lower_model.attributes.equipments.map(
                                    (el: any) => el.name,
                                  ),
                                  ...componentData.data.vehicle.lower_model.attributes.highlights.map(
                                    (el: any) => el.name,
                                  ),
                                ]}
                                priceDiff={
                                  +componentData.data.vehicle.price -
                                  +componentData.data.vehicle.lower_model.model.price
                                }
                              />
                            </div>
                          </>
                        )}
                      {componentData.data.vehicle?.showrooms?.length > 0 && (
                        <>
                          <div className={`${style.separator} section_content_padding`}>
                            <div className={`${style.separator} section_separator`}></div>
                          </div>
                          <div className={style.vehicle_section}>
                            <h3 className="main_section__title main_section__title--xsmall">{locale("showrooms")}</h3>
                            <ShowroomsList
                              showrooms={componentData.data.vehicle?.showrooms.map((showroom: any) => ({
                                name: showroom.name,
                                image: showroom.logo,
                                link: `/showrooms/showroom/${showroom.id}`,
                              }))}
                            />
                          </div>
                        </>
                      )}
                      {componentData.data.vehicle?.model?.brand?.service_centers?.length > 0 && (
                        <>
                          <div className={`${style.separator} section_content_padding`}>
                            <div className={`${style.separator} section_separator`}></div>
                          </div>
                          <div className={style.vehicle_section}>
                            <h3 className="main_section__title main_section__title--xsmall">
                              {locale("service_centers")}
                            </h3>
                            <div style={{ position: "relative" }}>
                              <div className="row">
                                {componentData.data.vehicle.model.brand.service_centers
                                  .filter((_: any, index: number) => index < 2)
                                  .map((center: any) => (
                                    <div key={center.id} className="col-sm-6">
                                      <SingleShowroomCard
                                        name={center.name}
                                        image={center.logo}
                                        link={`/service-centers/center/${center.id}`}
                                        location={center.address}
                                      />
                                    </div>
                                  ))}
                                <ViewMore link="/service-centers" />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {componentData.data.similarVehicles?.length > 0 && (
                        <>
                          <div className={`${style.separator} section_content_padding`}>
                            <div className={`${style.separator} section_separator`}></div>
                          </div>
                          <div className={style.vehicle_section}>
                            <h3 className="main_section__title main_section__title--xsmall">
                              {locale("similarVehicle").replace("%vehicleName%", locale(vehicleNames.plural))}
                            </h3>
                            <div className="row">
                              {componentData.data?.similarVehicles
                                .filter((_: any, i: number) => i < 2)
                                .map((vehicle: any) => (
                                  <div key={vehicle.id} className="col-md-6">
                                    <SingleUsedVehicleCard
                                      showroom={{
                                        is_showroom: isImported ? 1 : vehicle?.seller?.is_showroom,
                                        image: vehicle?.showroom?.logo || vehicle?.seller?.showroom?.logo,
                                        link: `/showrooms/${vehicle?.showroom?.id}`,
                                      }}
                                      image={vehicle.images[0]?.image}
                                      link={`/${vehicleCondition}-${vehicleNames.plural}/${vehicleNames.single}/${vehicle.id}`}
                                      isFeatured={vehicle.listing_period.is_featured}
                                      date={vehicle.created_at}
                                      location={
                                        vehicle?.region
                                          ? `${vehicle?.region?.name}, ${vehicle?.region?.city?.name}`
                                          : ""
                                      }
                                      name={`${vehicle?.model?.brand?.name} ${vehicle?.model?.name} ${vehicle?.model?.year}`}
                                      price={vehicle.price}
                                      phone={
                                        vehicle?.seller.is_showroom
                                          ? vehicle?.seller?.branch?.phone
                                          : vehicle?.seller?.user?.phone
                                      }
                                    />
                                  </div>
                                ))}
                            </div>
                          </div>
                        </>
                      )}
                      {vehicleCondition === "new" && componentData.data.news?.length > 0 && (
                        <>
                          <div className={`${style.separator} section_content_padding`}>
                            <div className={`${style.separator} section_separator`}></div>
                          </div>
                          <div className={style.vehicle_section}>
                            <h3 className="main_section__title main_section__title--xsmall">{locale("news")}</h3>
                            <div style={{ position: "relative" }}>
                              <div className="row">
                                {componentData.data.news
                                  .filter((_: any, index: number) => index < 2)
                                  .map((article: any) => (
                                    <div key={article.id} className="col-sm-6">
                                      <LatestNews {...article} />
                                    </div>
                                  ))}
                                <ViewMore link="/news" />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VehiclePage;

type ComponentPropsType = {
  vehicleCondition: VehicleConditions;
  vehicleNames: VehicleNames;
  isImported?: boolean;
  /**
   * if true, the vehicle is a distributor vehicle, and we won't show the contact button
   */
  isForDistributor?: boolean;
};
